import type { BetHistoryListType } from '~/socket/gamehistory/dto/gameHistory.dto';

// ↓ 币种信息
const currencyBetLimitInfo = {
    defaultBetAmount: 0, // 默认下注金额
    minBetAmount: 0, // 最小下注金额
    maxBets: 0, // 最大下注金额
    maxWin: 0, // 最大返现金额 
    defaultBet: 0, // 默认下注金额, 2024-6-28 新增 
}

const config = {
    btc: deepCopy(currencyBetLimitInfo),
    eth: deepCopy(currencyBetLimitInfo),
    usdt: deepCopy(currencyBetLimitInfo),
    cny: deepCopy(currencyBetLimitInfo),
    maxBet: 0,
    maxWin: 0,
    vipCoefficient: 0,
    minValue: 0,
    maxValue: 0,
    minRange: 1,
    maxRange: 1,
    totalRange: 1,
    coeff: 0,
    rtp: '', // 99.02%
    ertp: [], // ['99.04%', '99.05%', '99.08%', ......]
    // ---- ↑ 通用部分
    // ---- ↓ 特定游戏专用数据 ----------------------------------
    houseEdge: 0, // 同原站点，hilo 等游戏会用到
    coefficients: {}, // minesGame, stairs 等游戏会用到
    low: [], // kenoGame 游戏会用到
    medium: [], // kenoGame 游戏会用到
    hight: [], // kenoGame 游戏会用到
    rows: [...Array(13).keys()].map(()=>({length: 10, offset: 0})), // stairs 游戏楼层布局 
    tableList: [], // 抢红包游戏的大厅列表，通常有5个子项 
    halls: [], // 炸金花游戏的大厅列表，通常有5个子项 
    hallLimit: [], // 炸金花游戏的下注金额信息
};

export const JoinState = {
    config,
    hash: '',
    gameId: 0, // 游戏 id
    gameName: '', // 表示“已经”查询到的某某游戏的数据
    gameOfRoute: '', // 表示“已经” 到达了某某游戏页面
    gameRunning: false, // true 表示游戏进行中（用户此时离开游戏会弹出提示要求确认）
    gameBetFinished: false, // true 表示下注已经结束（详见页面底部注释）
    gameStartedInNewTab: false, // true 表示当前游戏在其它窗口打开了，当前窗口不可继续操作
    rollingAllowed: true,
    history: {
        all: [] as BetHistoryListType,
        rare: [] as BetHistoryListType,
        high: [] as BetHistoryListType,
        fun: [] as BetHistoryListType, // circle中用到的数据
        my: [] as BetHistoryListType, // circle中用到的数据
    },
    battle: null,
    inFavorite: 666,
    ...{
        jackpot: 0, // jackpot命中纪录
        jackpotDelay: 0, // 同上，延迟值用于界面显示，动画播放完毕后更新
        jackpotSize: 0, // 剩余jackpot（奖池余额）
        jackpotBetsNeed: 0, // jackpot需要的下注金额
        jackpotProgress: 0, // jackpot进度[circle]
        jackpotUser: [], // crash 游戏会用到
    },
    // ---- ↓ 🎈在特定游戏使用（这些属性记录了上局未完成的游戏数据） ↓ -------------------------------
    bets: [], // crash 游戏时，记录了本局游戏的玩家列表
    lastRound: {} as { [key: string]: any }, // 某些游戏会用到，如： hilo, blackjack, mines, crash, tower, pharaoh,
    activeBonusGame: {} as { [key: string]: any }, // pharaoh 游戏会用到
    betsOnline: [], // circle实时下注数据
    state: {}, // circle游戏当前下注状态
    zhajinhuaGame: {
        rtp: '',
    },
};

const gameHistoryResponseState = {
    isMine: false, // 标记此数据是否是当前用户的下注记录
    toDelay: false, // true 表示数据需要延迟显示，
    roll_number: 6910,
    hash: '813e07026f0d687420895c717535d690f6bf837eba29f52d09bb260cb2b460c0',
    amount: 10,
    balanceBefore: 9978.628,
    currency: 'usdt',
    isIn: true,
    multi: 1.9804,
    predictionRange: [2500, 7499], // spacedice 游戏 
    randomSeed: '6910_goEJSUcXfrJwoU',
    timestamp: '2023-12-12T03:24:47.806Z',
    user: {
        _id: '6526a269fffbbc179c0f48ac',
        avatar: 0,
        lvl: 1,
        name: 'User4176721',
    },
    winAmount: '19.804',
    _id: '6577d27fb8ba3bbce58197c6',
    game: {
        id: '62b42116c05afc151d1f53ba',
    },
};

const HistoryOnJoinState = {
    all: [],
    rare: [],
    high: [],
};

export interface ICoinFlip {
    prediction?: number;
    type: number;
    isFast: boolean;
    amount?: string | number;
    frontID: number; //下注时的毫秒数
}

export type JoinStateType = Partial<typeof JoinState>;
export type GameHistoryReponseStateType = typeof gameHistoryResponseState;
export type HistoryOnJoinStateType = typeof HistoryOnJoinState;

/* 
关于 JoinState.gameBetFinished 的说明（拷贝自 Victor 的消息）： 
情境: 
普通下注: isSubmiting 結束時會與gameBetFinished  同步
自動下注: isSubmiting 只有去按下停止時才會變成false

gameBetFinished  在自動下注時 請求發生前為True, 請求完後會改為false
*/

